import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  cookie: any;
  constructor() // readonly cookie: CookieService
  {}

  // storage service is used to set and remove data in localStoarge,
  // if in any case browser dosnt support local stoarge application will use cookies
  // automatically based on this service usage

  sessionStorage() {
    try {
      sessionStorage.setItem('key', 'value');
    } catch (e) {
      return false;
    }
    // tslint:disable-next-line:no-string-literal
    sessionStorage.removeItem('key');
    return true;
  }
  setData(key: string, value: any) {
    // window.sessionStorage.setItem(key, value);
    window.localStorage.setItem(key, value);
  }

  getData(key: string) {
    // if (this.sessionStorage()) {
    // } else {
    //   return this.cookie.get(key) || null;
    // }
    return window.localStorage[key];
    // return window.sessionStorage[key];
  }

  removeData(key: string) {
    delete window.sessionStorage[key];
  }

  removeAllData() {
    window.sessionStorage.clear();
    window.localStorage.clear();
  }

  setDataToSessionStorage() {
    const keys = [
      'userToken',
      'defaultDatePickerFormat',
      'appToken',
      'defaultDateFormat',
      'userId',
      'userPermission',
      'requestedUrl',
      'isLoggedIn',
      'user',
      'roles_data',
      'boards',
      'loggedInBoard',
      'pagePermission',
      'permisionGurds',
      'defaultDateZoneId',
      'leftNavs',
      'rolePermission'
    ];
    keys.map(key => {
      const val: any = window.localStorage.getItem(key);
      if (val) {
        window.localStorage.setItem(key, val);
        // window.localStorage.removeItem(key);
      }
    });
  }

  bindParamsForSessionSharing() {
    let data: any = {
      url: '',
      params: '',
      queryParams: ''
    };
    let search = window.location.search;
    let path = window.location.pathname;
    const queryParamsExists = search !== '' && search.includes('?');
    const paramsExists = path.includes(';');
    data.url = path;
    if (paramsExists) {
      const paramData = ':' + path.split(';').slice(1).join(';');
      data.url = path.split(';')[0];
      data.params = decodeURI(paramData)
        .substring(1)
        .split(';')
        .map(param => param.split('='))
        .reduce((values: any, [key, value]) => {
          values[key] = value;
          return values;
        }, {});
    } else {
      data.params = null;
    }
    if (queryParamsExists) {
      data.queryParams = decodeURI(search)
        .substring(1)
        .split('&')
        .map(param => param.split('='))
        .reduce((values: any, [key, value]) => {
          values[key] = value;
          return values;
        }, {});
    } else {
      data.queryParams = null;
    }
    return data;
  }

  setCookie(name: any, value: any) {
    document.cookie = name + '=' + value + '; path=/';
  }

  getCookie(c_name: any) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + '=');
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(';', c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return document.cookie.substring(c_start, c_end);
      }
    }
    return '';
  }

  removeCookie(name: any) {
    var now = new Date();
    now.setTime(now.getTime() - 1);
    document.cookie = `${name}=; expires=` + now.toISOString();
  }

  storeDataToSession(key: any, value: any) {
    window.sessionStorage.setItem(key, value);
  }
  getSessionData(key: any) {
    return window.sessionStorage.getItem(key);
  }
}
